import React, { useEffect, useState } from 'react';
import MotionAccuracy from './MotionAccuracy';
import { FiAward } from 'react-icons/fi';

const REFRESH_MS = 60000;
const formatCount = (value) => Number.isFinite(value) ? value.toLocaleString('en-GB') : '—';

export default function MotionLeaderboard({ api, reviewedCount, compact = false, hidePersonalCount = false, onAccuracyChange }) {
  const [result, setResult] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setResult(null);
    setFailed(false);
    let active = true;
    let loading = false;
    let lastAttempt = 0;
    const refresh = async () => {
      if (!api.leaderboard || loading || document.visibilityState === 'hidden' || (lastAttempt && Date.now() - lastAttempt < REFRESH_MS)) return;
      loading = true;
      lastAttempt = Date.now();
      try {
        const next = await api.leaderboard();
        if (active) { setResult(next); setFailed(false); }
      } catch (_) {
        if (active) setFailed(true);
      } finally { loading = false; }
    };
    refresh();
    const timer = window.setInterval(refresh, REFRESH_MS);
    document.addEventListener('visibilitychange', refresh);
    return () => { active = false; window.clearInterval(timer); document.removeEventListener('visibilitychange', refresh); };
  }, [api]);
  const accuracy = result?.personalAccuracy;
  useEffect(() => {
    onAccuracyChange?.(accuracy ? { ...accuracy, stale: failed } : null);
  }, [accuracy, failed, onAccuracyChange]);
  // Use the same optimistic total as personal progress, including pending saves and Undo.
  const entries = (result?.entries || []).map((entry) => entry.isYou && Number.isFinite(reviewedCount)
    ? { ...entry, reviewedCount }
    : entry);
  return <section className={`cr-motion-leaderboard${compact ? ' cr-motion-leaderboard--strip' : ''}`} aria-label="Motion review leaderboard">
    <div className="cr-leaderboard-heading"><h2><FiAward aria-hidden="true" /> Top motion reviewers</h2><span>All time</span></div>
    {entries.length ? <ol className="cr-leaderboard-list">
      {entries.map((entry, index) => <li key={index} className={entry.isYou ? 'is-you' : undefined} aria-label={`Rank ${entry.rank}: ${entry.name}${entry.isYou ? ' (you)' : ''}, ${formatCount(entry.reviewedCount)} reviews`}>
        <span className="cr-leaderboard-rank">#{entry.rank}</span>
        <span className="cr-leaderboard-name" title={entry.name}>{entry.name}{entry.isYou && <small> (you)</small>}</span>
        <strong>{formatCount(entry.reviewedCount)}</strong>
      </li>)}
    </ol> : <p className="cr-leaderboard-empty">{failed || !api.leaderboard ? 'Leaderboard temporarily unavailable.' : result ? 'Be the first to review a motion clip.' : 'Loading leaderboard…'}</p>}
    {(!hidePersonalCount || (failed && result)) && <div className="cr-leaderboard-footer">{!hidePersonalCount && <span aria-label="Your motion review count" aria-live="polite" title="Completed Real motion and False alarm answers. Not sure is excluded."><strong>{formatCount(reviewedCount)}</strong> motion reviews by you</span>}{!hidePersonalCount && <MotionAccuracy accuracy={accuracy ? { ...accuracy, stale: failed } : null} />}{failed && result && <span className="cr-leaderboard-stale">Updating when connected</span>}</div>}
  </section>;
}
